import {DateTime} from 'luxon';
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {Renewals} from '@br/idm-api';
import {BuyOrActivateLicenseModal, Loading, RenewalsChart, useCustomerApi, useIntlFormatter} from '@br/idm-components';
import {InfoItem} from '@br/mg-components';

import useStyles from './styles';

const RenewalsInfo = ({tenantId}: {tenantId: string}): JSX.Element => {
    const {t} = useTranslation(['renewals']);
    const {formatDate} = useIntlFormatter();

    const {tenantApi} = useCustomerApi();

    const [renewals, setRenewals] = useState<Renewals>();
    const styles = useStyles();

    useEffect(() => {
        void tenantApi
            .tenantRenewalsRetrieve({id: tenantId})
            .then(tenantRenewals => setRenewals(tenantRenewals.renewals));
    }, [tenantApi, tenantId]);

    if (!renewals) {
        return <Loading />;
    }

    const renewBefore = renewals.renewBefore && formatDate(DateTime.now().plus({day: renewals.renewBefore}).toJSDate());

    return (
        <div className={styles.wrapper}>
            <div>
                {renewBefore && (
                    <InfoItem
                        label={t('renewals:renewBefore', 'Renew before')}
                        value={renewBefore}
                    />
                )}
            </div>

            <RenewalsChart renewals={renewals} />

            <div className={styles.button}>
                <BuyOrActivateLicenseModal tenantId={tenantId} />
            </div>
        </div>
    );
};

export default RenewalsInfo;
